import { useEffect, useState } from "react";

import { Col, Pagination, Row, theme, Typography } from "antd";
import { LeftOutlined, RightOutlined } from "@ant-design/icons";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";

import { useLazyGetTopicsQuery } from "../../../redux/service.js";
import BaseButton from "@/components_v2/Button/BaseButton.js";
import { BUTTON_TYPES } from "@/components_v2/Button/constants.js";
import { PAGINATION } from "@/shared/utils/constants.tsx";
import TopicDescription from "./TopicDescription";

const itemRender = (_, type, originalElement, hasNext, hasPrevious) => {
  if (type === "prev") {
    return (
      <a
        className="py-2 px-3"
        style={{
          border: "1px solid rgba(198, 206, 220, 1)",
          color: hasPrevious ? "black" : "silver",
        }}
      >
        <LeftOutlined /> Previous
      </a>
    );
  }
  if (type === "next") {
    return (
      <a
        className="py-2 px-3"
        style={{
          border: "1px solid rgba(198, 206, 220, 1)",
          color: hasNext ? "black" : "silver",
        }}
      >
        Next <RightOutlined />
      </a>
    );
  }
  return originalElement;
};

const { Title } = Typography;

const TopicsList = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { token } = theme.useToken();

  const [paginateTopics, { data, isSuccess }] = useLazyGetTopicsQuery();
  const [pagination, setPagination] = useState({
    page: PAGINATION.PAGE.DEFAULT,
    pageSize: PAGINATION.PAGE_SIZE.DEFAULT,
  });

  useEffect(() => {
    paginateTopics({ ...pagination, ordering: "order" });
  }, [pagination]);

  return (
    isSuccess && (
      <div>
        <Row className="mb-2">
          <Col span={21}>
            <Title level={3} style={{ color: token.colorTextThird }}>
              {t("topics")}
            </Title>
          </Col>
          <Col span={3}>
            <BaseButton to={"/discussions/form"} type={BUTTON_TYPES.LINK}>
              {t("startADiscussion")}
            </BaseButton>
          </Col>
        </Row>
        {data.results.map((topic) => (
          <Row
            key={topic.id}
            style={{ backgroundColor: "rgba(242, 242, 245, 1)" }}
            className="mb-4 py-4 px-4"
          >
            <Col span={19}>
              <Title
                level={5}
                className="mb-2"
                style={{ color: token.colorTextThird, cursor: "pointer" }}
                onClick={() => navigate(`/community/topics/${topic.title}`)}
              >
                {topic.title}
              </Title>
              <TopicDescription description={topic.description} />
            </Col>
            <Col
              span={5}
              style={{ textAlign: "center", alignContent: "center" }}
            >
              <div>
                <Title level={1} style={{ color: "rgba(126, 128, 138, 1)" }}>
                  {topic.discussionsCount}
                </Title>
                <Title
                  level={5}
                  style={{ fontWeight: 400, color: "rgba(126, 128, 138, 1)" }}
                >
                  {t("discussions")}
                </Title>
              </div>
            </Col>
          </Row>
        ))}
        {data.next || data.previous ? (
          <Pagination
            rootClassName="mt-4 text-center"
            total={data.count}
            itemRender={(...props) =>
              itemRender(...props, data.next != null, data.previous != null)
            }
            showSizeChanger
            pageSize={pagination.pageSize}
            onChange={(page, pageSize) => setPagination({ page, pageSize })}
          />
        ) : null}
      </div>
    )
  );
};

export default TopicsList;
